'use client';

import Banana from '@cc-shopping/ui/composites/Banana';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (error) {
      datadogRum.addError(error, { message: 'Fatal error triggered root client error boundary' });
    }
  }, [error]);
  return (
    <html>
      <body>
        <Banana reset={reset} />
      </body>
    </html>
  );
}
